var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZoomIn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85173 1.02837L1 1M1 1L1.02551 5.28366M1 1L6.22409 6.80992M4.85173 16.9716L1 17M1 17L1.02551 12.7163M1 17L6.22409 11.1901M13.1483 1.02837L17 1M17 1L16.9745 5.28366M17 1L11.7759 6.80992M13.1483 16.9716L17 17M17 17L16.9745 12.7163M17 17L11.7759 11.1901",
    stroke: "#979797",
    strokeWidth: 1.12924
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZoomIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/zoomIn.e5fce0b56332d56c5653d1c3a697a0a6.svg";